import { Dispatch } from 'redux';
import {
    generateReportRequest,
    generateReportPolling,
    generateReportReady,
    generateReportFailure,
    cleanTermsConditionReport as cleanReducer
} from '../reducers/termsConditionReport';
import { axiosClient } from '../config/axios';
import { api } from '../config/api';
import { unauthorized } from '../reducers/unauthorized';
import { GetState } from '../config/store';

export const generateTermsConditionReport = () => (dispatch: Dispatch, getState: GetState) => _generateReport(dispatch, getState);
const _generateReport = async (dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: generateReportRequest });

        const response = await axiosClient.post(`${api.users}/terms-condition/report`);
        const reportId = response.data?.data?.reportId;

        dispatch({ type: generateReportPolling, payload: reportId });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.statusCode === 403 || errorResponse?.statusCode === 401 || error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch({ type: unauthorized });
            return;
        }
        dispatch({ type: generateReportFailure });
    }
};

export const checkTermsConditionReport = (reportId: string) => (dispatch: Dispatch, getState: GetState) => _checkReport(reportId, dispatch, getState);
const _checkReport = async (reportId: string, dispatch: Dispatch, getState: GetState) => {
    try {
        const response = await axiosClient.get(`${api.users}/terms-condition/report/${reportId}`);
        const report = response.data?.data?.report;

        if (report?.status === "ready") {
            dispatch({ type: generateReportReady, payload: report.url });
        } else if (report?.status === "failed") {
            dispatch({ type: generateReportFailure });
        }
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.statusCode === 403 || errorResponse?.statusCode === 401 || error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch({ type: unauthorized });
            return;
        }
        dispatch({ type: generateReportFailure });
    }
};

export const cleanTermsConditionReport = () => (dispatch: Dispatch) => dispatch({ type: cleanReducer });
